import { Tooltip } from '@mui/material';
import React from 'react';
import '../Beneficiary/styles/BeneficiaryList.css';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../shared/PageHeader';

const StatusCard = ({ title, count, net, percentage, color, textColor, border }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className='flex flex-col relative justify-between p-3 border rounded-lg shadow-md w-full'>
      <div
        className={`text-white absolute top-0 ${
          i18n.language == 'en' ? 'left-0' : 'right-0'
        } text-sm font-bold py-1 px-2 rounded-tl-md rounded-br-md w-max ${color}`}
      >
        {title}
      </div>
      <div className='flex justify-between flex-row-reverse items-center'>
        <div className='flex justify-between flex-col items-center'>
          <div>
            <p className={`text-2xl font-bold  ${textColor}`}>{count}</p>
            <p className='text-base text-gray-500 text-center'>{t('Active')}</p>
          </div>
          <div className='relative w-16 h-16 flex items-center justify-center rounded-full'>
            <svg className='absolute top-0 left-0 w-full h-full' viewBox='0 0 36 36'>
              <circle
                className='text-gray-300 stroke-current'
                strokeWidth='4'
                fill='transparent'
                r='16'
                cx='18'
                cy='18'
              />
              <circle
                className={`${border}`}
                strokeWidth='3'
                strokeDasharray='100'
                strokeDashoffset={100 - percentage}
                fill='transparent'
                r='16'
                cx='18'
                cy='18'
              />
            </svg>
            <p className={`text-sm ${textColor} font-semibold relative z-10`}>
              {percentage}
              <span className='text-xs'>%</span>
            </p>
          </div>
        </div>
        <div className=''>
          <p className='text-base text-gray-500'>{t('Totals')}</p>
          <p className={`text-xl font-bold ${textColor}`}>{net.toLocaleString()} SR</p>
        </div>
      </div>
    </div>
  );
};
const tableHeaders = t => [
  { name: t('Field Name') },
  { name: t('Frequency') },
  { name: t('Ratio') },
  { name: t('Status') }
];

function DenialManagement() {
  const { t, i18n } = useTranslation();
  const data = [{}, {}];
  return (
    <div className='claimsSubmission_container'>
      <div className='claimsSubmission_page'>
        <PageHeader
          title={t('Denial Management')}
          tooltip={t('Keep track of your claims submissions')}
          subtitle
        ></PageHeader>

        {/* <div className='mt-4'>
          <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 '>
            <StatusCard
              title={t('Ready For Submission')}
              count={3555}
              net={231540.79}
              percentage={99.89}
              color='!bg-primary'
              textColor='!text-primary'
              border='stroke-primary'
            />
            <StatusCard
              title={t('Validation Errors')}
              count={4}
              net={12135.46}
              percentage={40.11}
              color='bg-red-400'
              textColor='text-red-400'
              border='stroke-red-400'
            />
          </div>
          <div className='mt-4'>
            <div className='flex justify-between items-center'>
              <div>
                <h2 className='text-xl font-semibold text-black/70'>
                  {t('Upload Summary - Validation Errors')}
                </h2>
                <p className='text-gray-500 text-base'>
                  {t('Claim validations grouped by field name')}
                </p>
              </div>
            </div>
            <div className='super-git-table mt-2'>
              <table className='table-super-git'>
                <thead className='!p-0'>
                  <tr className='!p-0'>
                    {tableHeaders(t).map((el, index) => {
                      return (
                        <th
                          className='!p-2 !text-sm'
                          key={`tableHeaders_${index}`}
                        >
                          {el.name}
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {data?.map((el, index) => {
                    return (
                      <tr key={'beneficiariesData_' + index} className='!p-0'>
                        <td className='!p-1 !text-sm text-left'>name</td>
                        <td className='!p-1 !text-sm text-left'>12</td>
                        <td className='!p-1 !text-sm text-left'>4%</td>
                        <td className='!p-1 !text-sm text-left'>Failed</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default DenialManagement;
